module.exports = __webpack_public_path__ + "img/grzx_ck.82e5f189.svg";